import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Truck } from "lucide-react";
import { currentUser, currentRole, clearSession } from "@/lib/api";

export default function Navbar() {
  const nav = useNavigate();
  const user = currentUser();
  const role = currentRole();
  const logout = () => { clearSession(); nav("/"); };

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-slate-200" data-testid="customer-navbar">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <div className="w-9 h-9 rounded-lg bg-orange-500 text-white flex items-center justify-center shadow-md group-hover:shadow-orange-200 transition">
            <Truck size={20} strokeWidth={2.5} />
          </div>
          <div className="leading-tight">
            <div className="font-display font-extrabold text-xl text-slate-900">KARMIVO</div>
            <div className="text-[10px] uppercase tracking-widest text-orange-600 font-semibold">Reliable Labour. Smartly Dispatched.</div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-slate-700">
          <Link to="/" data-testid="nav-home" className="hover:text-orange-600">Home</Link>
          <Link to="/book" data-testid="nav-book-labour" className="hover:text-orange-600">Book Labour</Link>
          <Link to="/track" data-testid="nav-track-booking" className="hover:text-orange-600">Track Booking</Link>
          <Link to="/worker/register" data-testid="nav-join-worker" className="hover:text-orange-600">Join as Worker</Link>
          <Link to="/franchise/apply" data-testid="nav-franchise" className="hover:text-orange-600">Franchise Partner</Link>
          <Link to="/admin/login" data-testid="nav-admin" className="text-slate-500 hover:text-slate-900">Admin</Link>
        </nav>
        <div className="flex items-center gap-2">
          {user && role === "customer" ? (
            <>
              <span className="text-sm text-slate-600 hidden sm:block" data-testid="nav-user-name">Hi, {user.name}</span>
              <Button variant="outline" size="sm" onClick={logout} data-testid="nav-logout-btn">Logout</Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => nav("/customer/login")} data-testid="nav-customer-login-btn">Login</Button>
              <Button size="sm" className="bg-orange-500 hover:bg-orange-600" onClick={() => nav("/book")} data-testid="nav-book-cta">Book Now</Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
